"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertBrightnessListener: () => assertBrightnessListener,
  assertBrightnessValue: () => assertBrightnessValue,
  assertSystemMode: () => assertSystemMode
});
module.exports = __toCommonJS(validate_exports);
function assertBrightnessValue(value, verb) {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > 1) {
    throw new Error(`${verb}: value must be a number between 0 and 1`);
  }
}
var SYSTEM_MODES = [
  "manual",
  "automatic"
];
function assertSystemMode(mode) {
  if (mode !== "manual" && mode !== "automatic") {
    throw new Error(`Brightness.setSystemMode: mode must be one of: ${SYSTEM_MODES.join(", ")}.`);
  }
}
function assertBrightnessListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Brightness.addListener: listener must be a function");
  }
}
//# sourceMappingURL=validate.js.map
